import { render, staticRenderFns } from "./InjuryReportForm.vue?vue&type=template&id=6e591a2c"
import script from "./InjuryReportForm.vue?vue&type=script&lang=js"
export * from "./InjuryReportForm.vue?vue&type=script&lang=js"
import style0 from "./InjuryReportForm.vue?vue&type=style&index=0&id=6e591a2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports